import { useEffect, useMemo, useState } from 'react';
import * as React from 'react';
import ModalContext from './ModalContext';

type ModalContextProviderProps = React.PropsWithChildren<{}>;

function ModalContextProvider({ children }: ModalContextProviderProps) {
    const portalTargetId = 'modal-portal';
    const [activeModalId, setActiveModalId] = useState<string | null>(null);

    useEffect(() => {
        const portalTarget = document.createElement('div');
        portalTarget.id = portalTargetId;
        if (!document.getElementById(portalTargetId)) { document.body.appendChild(portalTarget); }
    }, [portalTargetId]);

    const contextValue = useMemo(() => ({
        activeModalId,
        setActiveModalId,
        portalTargetId,
    }), [activeModalId]);

    return (
        <ModalContext.Provider value={contextValue}>
            {children}
        </ModalContext.Provider>
    );
}

export default ModalContextProvider;
